import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestTcfGvlPut = {
    path: "/tcf/gvl",
    method: RouteHttpVerb.PUT
};
